import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Shield, Monitor, MapPin, Clock } from "lucide-react";

function fmtDate(iso) {
  if (!iso) return "-";
  try { return new Date(iso).toLocaleString("fr-FR"); } catch { return iso; }
}

function shortenUA(ua) {
  if (!ua) return "-";
  const m = ua.match(/(Chrome|Firefox|Safari|Edge|Opera)\/[\d.]+/);
  return m ? m[0] : ua.slice(0, 40);
}

export default function AdminLoginLogs() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/login-logs?limit=200")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-display text-3xl font-black text-[#0a1e3f]">Journal des connexions</h1>
        <p className="text-sm text-gray-500 mt-1">Historique des connexions (200 dernières entrées).</p>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 mbk-card-shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs uppercase tracking-widest text-gray-500">
            <tr>
              <th className="text-left p-4">Utilisateur</th>
              <th className="text-left p-4">Rôle</th>
              <th className="text-left p-4"><MapPin className="h-3 w-3 inline mr-1" />IP</th>
              <th className="text-left p-4"><Monitor className="h-3 w-3 inline mr-1" />Navigateur</th>
              <th className="text-left p-4"><Clock className="h-3 w-3 inline mr-1" />Date</th>
            </tr>
          </thead>
          <tbody data-testid="login-logs-body">
            {loading ? <tr><td colSpan={5} className="p-12 text-center text-gray-400">Chargement…</td></tr> :
              items.length === 0 ? <tr><td colSpan={5} className="p-12 text-center text-gray-400">Aucune connexion enregistrée.</td></tr> :
                items.map((l) => (
                  <tr key={l.id} className="border-t border-gray-100 hover:bg-gray-50/50" data-testid={`login-log-${l.id}`}>
                    <td className="p-4">
                      <div className="font-semibold text-[#0a1e3f]">{l.full_name || "-"}</div>
                      <div className="text-xs text-gray-500">{l.email}</div>
                    </td>
                    <td className="p-4">
                      <span className="text-xs font-bold px-2 py-1 rounded-full bg-[#0a1e3f]/10 text-[#0a1e3f] inline-flex items-center gap-1">
                        <Shield className="h-3 w-3" /> {l.role}
                      </span>
                    </td>
                    <td className="p-4 font-mono text-xs">{l.ip || "-"}</td>
                    <td className="p-4 text-xs text-gray-500">{shortenUA(l.user_agent)}</td>
                    <td className="p-4 text-xs text-gray-600">{fmtDate(l.created_at)}</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
